import React from 'react'
import LineCheckCircleIcon from 'LuxKit/Icons/line/LineCheckCircleIcon'
import LineExclamationTriangleIcon from 'LuxKit/Icons/line/LineExclamationTriangleIcon'
import LineTimesCircleIcon from 'LuxKit/Icons/line/LineTimesCircleIcon'
import Tooltip from 'LuxKit/Tooltip'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'

interface Props {
  status?: App.OrderItemStatus
}

export default function LesaPurchaseSummaryOrderItemStatus({ status }: Props) {
  switch (status) {
    case 'completed':
      return <Tooltip description="Booking confirmed."><BodyTextBlock variant="small" startIcon={<LineCheckCircleIcon size="XS" colour="success" />}>Booking confirmed.</BodyTextBlock></Tooltip>
    case 'pending':
      return <Tooltip description="Request pending..."><BodyTextBlock variant="small" startIcon={<LineExclamationTriangleIcon size="XS" colour="success" />}>Request pending...</BodyTextBlock></Tooltip>
    case 'cancelled':
      return <Tooltip description="Booking cancelled"><BodyTextBlock variant="small" startIcon={<LineTimesCircleIcon size="XS" colour="critical" />}>Booking cancelled</BodyTextBlock></Tooltip>
    case 'awaiting_dates':
      return <Tooltip description="Dates to be selected"><BodyTextBlock variant="small" startIcon={<LineExclamationTriangleIcon size="XS" colour="warning" />}>Dates to be selected</BodyTextBlock></Tooltip>
    case 'needsDetails':
      return <Tooltip description="Traveller details needed"><BodyTextBlock variant="small" startIcon={<LineExclamationTriangleIcon size="XS" colour="warning" />}>Traveller details needed</BodyTextBlock></Tooltip>
    case 'created':
      return <Tooltip description="Booking confirmed."><BodyTextBlock variant="small" startIcon={<LineCheckCircleIcon size="XS" colour="success" />}>Booking confirmed.</BodyTextBlock></Tooltip>
    default:
      return null
  }
}
